import { useMediaQuery } from "react-responsive";

export const useGetMediaQuery = () => {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-width: 1224px)",
  });
  const isBigScreen = useMediaQuery({ query: "(min-width: 1824px)" });
  const isTablet = useMediaQuery({ query: "(max-width: 1224px)" });
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  return { isDesktopOrLaptop, isBigScreen, isTablet, isMobile };
};
